import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import {
  SALES_ORDER_DATE_RANGE_FILTER_KEYS,
  SALES_ORDER_DATE_RANGE_TYPE_TO_LABEL,
  SALES_ORDER_STATUS_TO_LABEL,
} from "../../../constants"
import type { SalesOrderSearchParams } from "../../../schemas"

import { FilterChip } from "@/components/common/Filters"

interface SalesOrderFilterChipsProps {
  searchParams: SalesOrderSearchParams
  onRemove: (
    keyOrKeys: keyof SalesOrderSearchParams | (keyof SalesOrderSearchParams)[],
    value?: string | number
  ) => void
}

export const SalesOrderFilterChips: FC<SalesOrderFilterChipsProps> = ({ searchParams, onRemove }) => {
  const { statuses = [], dateFrom, dateTo, dateRangeType } = searchParams

  const hasActiveFilters = statuses.length > 0 || !!dateFrom || !!dateTo

  if (!hasActiveFilters) return null

  return (
    <Box className='flex flex-wrap items-center gap-2' data-testid='customer-orders.so-filter-chips'>
      <Typography variant='body1'>Filters:</Typography>
      {statuses.map((status) => (
        <FilterChip
          key={status}
          testId={`customer-orders.so-filter-chips.status-chip-${status}`}
          label={`Status: ${SALES_ORDER_STATUS_TO_LABEL[status]}`}
          onDelete={() => onRemove("statuses", status)}
        />
      ))}
      {(dateFrom || dateTo) && (
        <FilterChip
          testId='customer-orders.so-filter-chips.date-range-chip'
          label={`${dateRangeType ? SALES_ORDER_DATE_RANGE_TYPE_TO_LABEL[dateRangeType] : "Date"}: ${dateFrom ?? "—"} – ${dateTo ?? "—"}`}
          onDelete={() => onRemove(SALES_ORDER_DATE_RANGE_FILTER_KEYS)}
        />
      )}
    </Box>
  )
}
